<div class="flex gap-4 items-center flex-wrap">
  <div>
    <p-floatlabel variant="on">
      <p-inputNumber
        [ngModel]="costField()().value()"
        (ngModelChange)="setControlValue(costField(), $event)"
        [ngModelOptions]="{ standalone: true }"
        (onBlur)="markTouched(costField())"
        [disabled]="costField()().disabled()"
        [inputStyle]="{
          width: getCurrencyInputWidth(costField()().value()),
          textAlign: 'center',
        }"
        [min]="-9999999"
        [max]="9999999"
        [mode]="'currency'"
        [currency]="currencyCode()"
        locale="en-US"
      >
      </p-inputNumber>
      <label>{{ costLabel() }}</label>
    </p-floatlabel>
  </div>
  <div>
    <i class="pi pi-plus-circle text-2xl"></i>
  </div>
  <div class="flex flex-row gap-2 items-center">
    <p-floatlabel variant="on">
      <p-inputNumber
        [ngModel]="markupField()().value()"
        (ngModelChange)="setControlValue(markupField(), $event)"
        [ngModelOptions]="{ standalone: true }"
        (onBlur)="markTouched(markupField())"
        [disabled]="markupField()().disabled()"
        [inputStyle]="{
          width: getCurrencyInputWidth(markupField()().value()),
          textAlign: 'center',
        }"
        [min]="-9999999"
        [max]="9999999"
        [mode]="'currency'"
        [currency]="currencyCode()"
        locale="en-US"
      >
      </p-inputNumber>
      <label>{{ markupLabel() }}</label>
    </p-floatlabel>
    @if (markupPercentField()) {
      <p-floatlabel variant="on">
        <p-inputNumber
          [ngModel]="markupPercentField()!().value()"
          (ngModelChange)="setControlValue(markupPercentField()!, $event)"
          [ngModelOptions]="{ standalone: true }"
          (onBlur)="markTouched(markupPercentField()!)"
          [disabled]="markupPercentField()!().disabled()"
          [inputStyle]="{
            width: `calc(${Math.max(1, markupPercentField()!().value().toString().length)}ch + 1ch + 2em)`,
            textAlign: 'center',
          }"
          [min]="-999"
          [max]="999"
          [suffix]="'%'"
          [minFractionDigits]="0"
          [maxFractionDigits]="2"
        >
        </p-inputNumber>
        <label></label>
      </p-floatlabel>
    }
  </div>
  @if (priceField()) {
    <div class="flex gap-4 items-center">
      <div>
        <i class="pi pi-equals text-2xl"></i>
      </div>
      <p-floatlabel variant="on">
        <p-inputNumber
          [ngModel]="priceField()!().value()"
          (ngModelChange)="setControlValue(priceField()!, $event)"
          [ngModelOptions]="{ standalone: true }"
          (onBlur)="markTouched(priceField()!)"
          [disabled]="priceField()!().disabled()"
          [inputStyle]="{
            width: getCurrencyInputWidth(priceField()!().value()),
            textAlign: 'center',
          }"
          [min]="-9999999"
          [max]="9999999"
          [mode]="'currency'"
          [currency]="currencyCode()"
          locale="en-US"
        >
        </p-inputNumber>
        <label>{{ priceLabel() }}</label>
      </p-floatlabel>
    </div>
  }
  @if (isDirty()) {
    <div>
      <p-button
        icon="pi pi-undo"
        severity="secondary"
        [rounded]="true"
        (onClick)="resetPricing()"
        size="small"
      />
    </div>
  }
</div>
